module.exports = __webpack_public_path__ + "static/media/testfile_xmp.b957c208.zip";